<template>
  <div>
    <header class="navbar">
      <div class="logo">
        <img
          src="@/assets/images/pages/medlab_logo.png"
          alt="logo"
          class="mx-auto"
        />
      </div>

      <button class="menu-toggle" @click="toggleMenu">☰</button>

      <nav :class="{ open: isMenuOpen }">
        <ul>
          <li><router-link :to="{ path: '/', hash: '#home' }">HOME</router-link></li>
          <li><router-link :to="{ path: '/', hash: '#features' }">FEATURES</router-link></li>
          <li><router-link :to="{ path: '/', hash: '#pricing' }">PRICING</router-link></li>
          <li><router-link :to="{ path: '/', hash: '#partners' }">CHANNEL PARTNERS</router-link></li>
          <li><router-link :to="{ path: '/', hash: '#contact' }">CONTACT</router-link></li>
          <li><router-link to="/tutorial" class="tutorial-btn">TUTORIAL</router-link></li>
          </ul>
      </nav>
    </header>
  </div>
</template>

<script>
export default {
  name: "AppNavbar",
  data() {
    return {
      isMenuOpen: false,
      searchQuery: "",
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
   
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        this.isMenuOpen = false;
      }
    },
  },
};
</script>




<style scoped>



.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 12px 24px;
  color: #206A98;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  border-bottom: 1px solid #eee;
  
}


.logo {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: bold;
  color: #206A98;
}
.logo img {
  margin-right: 8px;
  /* width: 100%; */
  height: 32px;
  width: auto;
}


nav {
  display: flex;
  align-items: center;
  gap: 20px;
}
nav ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}
nav ul li {
  margin-left: 20px;
}
nav ul li a {
  color: #206A98;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s;
}
nav ul li a:hover {
  color: #009886;
}
.active {
  border-bottom: 2px solid #fff;
  padding-bottom: 2px;
}
.tutorial-icon {
  width: 25px;    /* set your desired width */
  height: 25px;   /* set your desired height */
  object-fit: contain; /* keeps proportions */
  display: block;
}

.menu-toggle {
  display: none;
  font-size: 26px;
  background: transparent;
  border: none;
  color: #206A98;
  cursor: pointer;
}

 /* Responsive Styles */
@media (max-width: 992px) {
  /* Tablet and Mobile (≤992px) */
  nav {
    display: none;
    position: absolute;
    top: 60px;
    right: 20px;
    background: #206A98;
    width: 240px;
    border-radius: 8px;
    padding: 15px;
    flex-direction: column;
    align-items: stretch;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease-in-out;
  }

  nav.open {
    display: flex;
  }

  nav ul {
    flex-direction: column;
    text-align: left;
  }

  nav ul li {
    margin: 12px 0;
  }

  nav ul li a {
    color: #fff;
    font-size: 16px;
  }

  .active {
    border-bottom: none;
    font-weight: bold;
  }

  .menu-toggle {
    display: block;
  }

  .logo {
    display: flex;
    align-items: center;
  }
}

@media (max-width: 480px) {
  /* Mobile (≤480px) adjustments */
  .navbar {
    padding: 10px 15px;
  }

  nav {
    width: 200px;
    padding: 12px;
  }

  nav ul li a {
    font-size: 14px;
  }

  .logo img {
    height: 28px;
  }
}
</style>






